module.exports = __webpack_public_path__ + "img/dbg-sync.236700d5.png";